export default class Share {};
